/*
 * AeroPress AJAX cart helper for the LP's "Meet Your Match" buttons.
 * Mirrors the Walnut/Focal theme's own ProductForm flow: add via the Section
 * Rendering API (sections=mini-cart), then dispatch the theme's cart events so
 * its <cart-drawer id="mini-cart"> re-renders and opens itself and <cart-count>
 * updates. Does NOT replace any theme DOM nodes.
 */
(function () {
  if (window.AeroPressCart) return;

  var themeVars = window.themeVariables || {};
  var routes = themeVars.routes || {};
  var settings = themeVars.settings || {};

  function jsUrl(base, fallback) {
    var u = base || fallback;
    return u.replace(/\.js$/, '') + '.js';
  }
  var addUrl = jsUrl(routes.cartAddUrl, '/cart/add');
  var cartUrl = jsUrl(routes.cartUrl, '/cart');

  function formatMoney(cents) {
    try {
      var value = (cents / 100).toFixed(2);
      var fmt = (settings.moneyFormat) || '${{amount}}';
      return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function dispatch(name, detail) {
    document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
  }

  function add(variantId, quantity, button) {
    if (!variantId) return Promise.reject(new Error('Missing variant id'));
    var label = button ? button.querySelector('[data-atc-label]') : null;
    var originalText = label ? label.textContent : '';

    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    if (label) label.textContent = 'Adding…';

    var form = new FormData();
    form.append('id', variantId);
    form.append('quantity', quantity || 1);

    return fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: form
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        });
      })
      .then(function (addJson) {
        // The item is in the cart server-side now. Everything below is best-effort
        // UI; guard it so a misbehaving third-party cart listener can't block the
        // success state.
        try {
          if (button) {
            button.dispatchEvent(new CustomEvent('variant:added', {
              bubbles: true,
              detail: { variant: addJson.items ? addJson.items[0] : addJson }
            }));
          }
          // Full cart (has item_count) for the header count / free-shipping bar.
          fetch(cartUrl).then(function (r) { return r.json(); })
            .then(function (cart) { dispatch('cart:updated', { cart: cart }); })
            .catch(function () {});
          // Open the theme drawer and let IT refetch the mini-cart section fresh
          // from the server (no `cart` payload → _rerenderCart's refetch branch),
          // so we never feed it stale client-side section HTML.
          var openMiniCart = settings.cartType === 'drawer' && (!button || !button.closest('.drawer'));
          dispatch('cart:refresh', { openMiniCart: openMiniCart });
        } catch (e) { if (window.console) console.error('[AeroPressCart]', e); }

        if (label) label.textContent = 'Added ✓';
        setTimeout(function () {
          if (label) label.textContent = originalText || 'Add To Cart';
          if (button) { button.classList.remove('is-loading'); button.disabled = false; }
        }, 1400);
      })
      .catch(function (err) {
        if (label) label.textContent = originalText || 'Add To Cart';
        if (button) { button.classList.remove('is-loading'); button.disabled = false; }
        if (window.console) console.error('[AeroPressCart]', err);
      });
  }

  window.AeroPressCart = { add: add, formatMoney: formatMoney };

  // Global delegation for any element with [data-ap-add] (our LP buttons only).
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ap-add]');
    if (!trigger) return;
    event.preventDefault();
    if (trigger.disabled) return;
    add(trigger.getAttribute('data-variant-id'), 1, trigger);
  });
})();
